export default "__VITE_ASSET__DoNF8YAN__"